// src/theme.js
import { createTheme } from '@mui/material/styles';

const primaryColorLight = '#1E88E5'; // أزرق قوي
const secondaryColor = '#1565C0';    // أزرق أغمق

const baseTypography = {
  fontWeight: 600,
  h1: { fontWeight: 'bold' },
  h2: { fontWeight: 600 },
  h3: { fontWeight: 500 },
  h4: { fontWeight: 400 },
  h5: { fontWeight: 400 },
  h6: { fontWeight: 400 },
};

const lightPalette = {
  mode: 'light',
  primary: { main: primaryColorLight },
  secondary: { main: secondaryColor },
  nav: {
    main: '#FFFFFF',
    link: '#4A5568',
    hover: primaryColorLight,
    btn: secondaryColor,
  },
  footer: { main: '#0D1B2A', link: '#fff', hover: '#A69F9F' },
  background: {
    default: '#E9EEF5',
    section: '#F1F4FA',
    card: '#FFFFFF',
    input: '#FFFFFF',
    form: '#FFFFFF',
  },
  divider: '#D0D7E2',
  boxShadow: '0px 4px 10px 0px rgba(15, 23, 42, 0.12)',
  editor: {
    toolbar: '#F4F6FB',
    background: '#FFFFFF',
    border: '#E0E6F0',
    inputBackground: '#FFFFFF',
    placeholder: '#94A3B8',
    divider: '#E2E8F0',
  },
};

const darkPalette = {
  mode: 'dark',
  primary: { main: primaryColorLight },
  secondary: { main: '#1F2937' },
  nav: { main: '#020617', link: '#E5E7EB', hover: '#A69F9F', btn: '#FFFFFF' },
  footer: { main: '#020617', link: '#FFFFFF', hover: '#A69F9F' },
  background: {
    default: '#020617',
    section: '#050A15',
    card: '#0F172A',
    input: '#020617',
    form: '#020617',
  },
  divider: '#1E293B',
  boxShadow: '0px 4px 10px 0px rgba(15, 23, 42, 0.6)',
  editor: {
    toolbar: '#020617',
    background: '#020617',
    border: '#1E293B',
    inputBackground: '#020617',
    placeholder: '#6B7280',
    divider: '#1F2937',
  },
};

const getPalette = (mode) => (mode === 'dark' ? darkPalette : lightPalette);

const theme = (mode = 'light') =>
  createTheme({
    palette: getPalette(mode),
    typography: baseTypography,
  });

export default theme;
